import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationFundraisingStarted.vue";

export const selector = (item: Notification): boolean => {
  return item.type === NotificationType.FUNDRAISING_GOAL_STARTED;
};
